import { Box, Divider, Skeleton } from "@mui/material"

export const SkeletonVelesTable = () => {
  return <>
    <Box sx={{ width: '100%' }}>
      <Skeleton animation="pulse" width={150} height={75} />
      <Divider style={{ margin: '16px 0', borderBottomWidth: '2px', borderBottomColor: 'rgba(0,0,0,0.5)' }} />

      <Skeleton animation="pulse" width={300} height={75} />
      <Skeleton animation="pulse" height={100} />
      <Skeleton animation="pulse" height={50} />
      <Skeleton animation="pulse" height={50} />

    </Box>
  </>
}